










import Vue from 'vue';

/**
 * Renders a icon using the Material Design Icons web font in the 'baseline' style.
 * See https://material.io/resources/icons/?style=baseline for a full list of icons
 */
export default Vue.extend({
  name: 'SIcon',
  props: {
    /**
     * The icon name
     * See https://material.io/resources/icons/?style=baseline for a full list of icons
     */
    icon: {
      type: String,
      required: true,
    },
    /**
     * Can be a hex colour or a colour name, e.g 'primary'
     */
    color: {
      type: String,
      required: false,
    },
    /**
     * Size can be expressed as a pixel size (number)...
     * or as one of a few pre-defined string sizes
    */
    size: {
      type: [String, Number],
      required: false,
    },
  },
  computed: {
    pixelSize(): number | null {
      if (typeof this.size === 'number') {
        return this.size;
      }
      return null;
    },
    stringSize(): string | null {
      if (typeof this.size === 'string') {
        return this.size;
      }
      return null;
    },
  },
});
